import { useNavigate } from "react-router-dom";
import type { Projeto } from "@/types/ui-models";
import ProjectStatusBadge from "./ProjectStatusBadge";
import ProjectProgressBar from "./ProjectProgressBar";

interface ProjectTableProps {
  projetos: Projeto[];
}

export default function ProjectTable({ projetos }: ProjectTableProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-card border border-background-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-background-200 bg-background-50">
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Projeto</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Tipo</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Município/UF</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Cliente</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Status</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap min-w-[140px]">Progresso</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Árvores</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Espécies</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Última Atualização</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-foreground-500 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {projetos.map((proj) => (
              <tr
                key={proj.id}
                className="border-b border-background-200 hover:bg-background-50 transition-colors cursor-pointer"
                onClick={() => navigate(`/projetos/${proj.id}`)}
              >
                <td className="px-4 py-3">
                  <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">{proj.nome}</p>
                </td>
                <td className="px-4 py-3">
                  <span className="text-xs text-foreground-600 bg-background-100 px-2 py-0.5 rounded-md whitespace-nowrap">{proj.tipo}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-foreground-700 whitespace-nowrap">
                    {proj.municipio ? `${proj.municipio}${proj.uf ? `/${proj.uf}` : ""}` : "—"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-foreground-700 max-w-[160px] truncate">{proj.cliente || "—"}</span>
                </td>
                <td className="px-4 py-3">
                  <ProjectStatusBadge status={proj.status} />
                </td>
                <td className="px-4 py-3">
                  <ProjectProgressBar progresso={proj.progresso} size="sm" />
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm font-medium text-foreground-900 tabular-nums">{proj.totalArvores.toLocaleString("pt-BR")}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-foreground-700 tabular-nums">{proj.especiesIdentificadas}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    {proj.ultimaAtualizacao ? new Date(proj.ultimaAtualizacao).toLocaleDateString("pt-BR") : "—"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-1">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/projetos/${proj.id}`);
                      }}
                      className="w-7 h-7 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center hover:bg-primary-100 transition-colors cursor-pointer"
                      title="Abrir projeto"
                    >
                      <i className="ri-folder-open-line text-xs"></i>
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/mapa?projeto=${proj.id}`);
                      }}
                      className="w-7 h-7 rounded-md bg-accent-50 text-accent-600 flex items-center justify-center hover:bg-accent-100 transition-colors cursor-pointer"
                      title="Ver no mapa"
                    >
                      <i className="ri-map-2-line text-xs"></i>
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/relatorios?projeto=${proj.id}`);
                      }}
                      className="w-7 h-7 rounded-md bg-secondary-50 text-secondary-600 flex items-center justify-center hover:bg-secondary-100 transition-colors cursor-pointer"
                      title="Relatório"
                    >
                      <i className="ri-file-chart-line text-xs"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}